// 接口配置

import request from './request'

// 留给下个人
// axios已封装好
// post请求：
// 如果是form表单类型，参数放在params
// 如果是常规body类型，参数放在data
// 会自动根据传递的参数是data还是params进行正确请求

// 应用管理类

export const api = '/api/console/v1';

export const appapi = '/appapi';

export default {
    // 获取oppo广告组的deeplink链接
    apiGetdeeplink(params){
        return request({
            url: api + '/running/luckystat/getdeeplink',
            method: 'post',
            params: params
        })
    },
    // 获取广告当日消耗
    apiGetadcost(params){
        return request({
            url: api + '/running/luckystat/getadcost',
            method: 'post',
            params: params
        })
    },
    // 设置广告账户日预算
    apiUpdbudget(params){
        return request({
            url: api + '/running/luckystat/updbudget',
            method: 'post',
            params: params
        })
    },
    // 广告组开关
    updateSwitch(params){
        return request({
            url: api + '/running/luckystat/updswitch',
            method: 'post',
            params: params
        })
    },
    // 广告组转化出价
    updateAdPrice(params){
        return request({
            url: api + '/running/luckystat/updprice',
            method: 'post',
            params: params
        })
    },
    // 快应用广告账户详情
    apiLuckyStatAdAccount(params){
        return request({
            url: api + '/running/luckystat/adaccount',
            method: 'post',
            params: params
        })
    },
    // 通用-获取广告主
    apiCommonAdvertisers(params) {
        return request({
            url: api + '/running/common/advertisers',
            method: 'get',
            params: params
        })
    },
    // 通用-获取应用
    apiCommonApps(params) {
        return request({
            url: api + '/running/common/apps',
            method: 'get',
            params: params
        })
    },
    // 通用-获取任务墙
    apiCommonIwalls(params) {
        return request({
            url: api + '/running/common/iwalls',
            method: 'get',
            params: params
        })
    },
    // 通用-获取渠道
    apiCommonChannels() {
        return request({
            url: api + '/running/common/channels',
            method: 'get',
        })
    },
    // 通用-获取渠道位置
    apiCommonChannelSlots(params) {
        return request({
            url: api + '/running/common/channel/slots',
            method: 'get',
            params: params,
        })
    },
    // 通用-获取财务收支项
    apiCommonFinanceItems(params) {
        return request({
            url: api + '/running/common/finance/items',
            method: 'get',
            params: params
        })
    },
    // 通用-获取商品分类
    apiCommonCommodityCategories(params) {
        return request({
            url: api + '/running/common/commodity/categories',
            method: 'get',
            params: params
        })
    },
    // 通用-获取商品品牌
    apiCommonCommodityBrands(params) {
        return request({
            url: api + '/running/common/commodity/brands',
            method: 'get',
            params: params
        })
    },
    // 通用-获取商品策略
    apiCommonCommodityStrategies(params) {
        return request({
            url: api + '/running/common/commodity/strategies',
            method: 'get',
            params: params
        })
    },
    // 通用-获取广告位
    apiCommonAdSlots(params) {
        return request({
            url: api + '/running/common/ad/slots',
            method: 'get',
            params: params
        })
    },
    // 通用-获取资源位
    apiCommonAdResources(params) {
        return request({
            url: api + '/running/common/ad/resources',
            method: 'get',
            params: params
        })
    },
    // 通用-获取测评(old)
    apiCommonMeasures(params) {
        return request({
            url: api + '/running/common/measures',
            method: 'get',
            params: params
        })
    },
    // 通用-获取测评分类
    apiCommonAppraiseClasses() {
        return request({
            url: api + '/running/common/appraise/classes',
            method: 'get',
        })
    },
    // 通用-获取测评
    apiCommonAppraises(params) {
        return request({
            url: api + '/running/common/appraises',
            method: 'get',
            params: params
        })
    },
    // 通用-获取小说分类
    apiCommonBookClasses() {
        return request({
            url: api + '/running/common/book/classes',
            method: 'get',
        })
    },
    // 通用-获取壁纸分类
    apiCommonWallpaperClasses() {
        return request({
            url: api + '/running/common/wallpaper/classes',
            method: 'get',
        })
    },
    // 通用-获取小说
    apiCommonBooks(data) {
        return request({
            url: api + '/running/common/books',
            method: 'get',
            params: data
        })
    },
    // 通用-获取短剧
    apiCommonShortplays(data) {
        return request({
            url: api + '/running/common/shortplays',
            method: 'get',
            params: data
        })
    },
    apiCommonVshortplays(data) {
        return request({
            url: api + '/running/common/vshortplays',
            method: 'get',
            params: data
        })
    },
    apiCommonOshortplays(data) {
        return request({
            url: api + '/running/common/oshortplays',
            method: 'get',
            params: data
        })
    },
    // 通用-获取短剧分类
    apiCommonShortplayClasses() {
        return request({
            url: api + '/running/common/shortplay/classes',
            method: 'get',
        })
    },
    // 通用-获取操作员
    apiCommonOperators() {
        return request({
            url: api + '/running/common/operators',
            method: 'get',
        })
    },
    // 通用-获取投放平台
    apiCommonIssuePlatforms() {
        return request({
            url: api + '/running/common/issue/platforms',
            method: 'get',
        })
    },
    // 通用-获取投放平台流量类型
    apiCommonIssueFlows(params) {
        return request({
            url: api + '/running/common/issue/flows',
            method: 'get',
            params: params
        })
    },
    // 通用-获取投放平台效果类型
    apiCommonIssueEffects(params) {
        return request({
            url: api + '/running/common/issue/effects',
            method: 'get',
            params: params
        })
    },
    // 通用-获取动作来源
    apiCommonActionSources(params) {
        return request({
            url: api + '/running/common/action/sources',
            method: 'get',
            params: params
        })
    },
    // 通用-获取动作场景
    apiCommonActionScenes(params) {
        return request({
            url: api + '/running/common/action/scenes',
            method: 'get',
            params: params
        })
    },
    // 通用-获取动作编码
    apiCommonActionCodes(params) {
        return request({
            url: api + '/running/common/action/codes',
            method: 'get',
            params: params
        })
    },
    
    // 应用
    apiApps(data) {
        return request({
            url: api + '/running/app/apps',
            method: 'post',
            params: Object.assign({ page_index: 1, page_size: 20, }, data)
        })
    },
    apiAddApp(data) {
        return request({
            url: api + '/running/app/new',
            method: 'post',
            params: data
        })
    },
    apiGetApp(data) {
        return request({
            url: api + '/running/app/app',
            method: 'post',
            params: Object.assign(data)
        })
    },
    apiUpdateApp(data) {
        return request({
            url: api + '/running/app/update',
            method: 'post',
            params: data
        })
    },
    apiDeleteApp(data) {
        return request({
            url: api + '/running/app/delete',
            method: 'post',
            params: data
        })
    },

    // 应用配置
    apiAppConfigList(params) {
        return request({
            url: api + '/running/app/config/list',
            method: 'post',
            params: params
        })
    },
    apiAppConfigEdit(data) {
        return request({
            url: api + '/running/app/config/edit',
            method: 'post',
            data: data
        })
    },
    apiAppConfigCopy(params) {
        return request({
            url: api + '/running/app/config/copy',
            method: 'post',
            params: params
        })
    },
    apiAppConfigDelete(params) {
        return request({
            url: api + '/running/app/config/delete',
            method: 'post',
            params: params
        })
    },
    apiAppConfigSet(params) {
        return request({
            url: api + '/running/app/config/set',
            method: 'post',
            params: params
        })
    },

    // 应用子配置
    apiAppSubconfigEdit(data) {
        return request({
            url: api + '/running/app/config/subconfig/edit',
            method: 'post',
            data: data
        })
    },
    apiAppSubconfigDelete(params) {
        return request({
            url: api + '/running/app/config/subconfig/delete',
            method: 'post',
            params: params
        })
    },
    apiAppSubconfigSet(params) {
        return request({
            url: api + '/running/app/config/subconfig/set',
            method: 'post',
            params: params
        })
    },
    apiAppSubconfigAdSwitch(params) {
        return request({
            url: api + '/running/app/config/subconfig/adswitch',
            method: 'post',
            params: params
        })
    },
    
    // 渠道
    apiChannels(data) {
        return request({
            url: api + '/running/channel/channels',
            method: 'post',
            params: Object.assign({ page_index: 1, page_size: 20, }, data)
        })
    },
    apiGetChannel(data) {
        return request({
            url: api + '/running/channel/channel',
            method: 'post',
            params: data
        })
    },
    apiAddChannel(data) {
        return request({
            url: api + '/running/channel/add',
            method: 'post',
            data
        })
    },
    apiUpdateChannel(data) {
        return request({
            url: api + '/running/channel/update',
            method: 'post',
            data
        })
    },
    apiDeleteChannel(data) {
        return request({
            url: api + '/running/channel/delete',
            method: 'post',
            params: data
        })
    },
    apiEditChannelSlot(data) {
        return request({
            url: api + '/running/channel/slot/edit',
            method: 'post',
            data
        })
    },
    apiDeleteChannelSlot(data) {
        return request({
            url: api + '/running/channel/slot/delete',
            method: 'post',
            params: data
        })
    },

    // 渠道返点
    apiChannelRebateList(params) {
        return request({
            url: api + '/running/channel/rebate/list',
            method: 'post',
            params: params
        })
    },
    apiChannelRebateEdit(data) {
        return request({
            url: api + '/running/channel/rebate/edit',
            method: 'post',
            data: data
        })
    },
    apiChannelRebateDelete(params) {
        return request({
            url: api + '/running/channel/rebate/delete',
            method: 'post',
            params: params
        })
    },

    // 广告主
    apiGetAdvertisers(params) {
        return request({
            url: api + '/running/advertiser/advertisers',
            method: 'post',
            params: params
        })
    },
    apiGetAdvertiser(params) {
        return request({
            url: api + '/running/advertiser/advertiser',
            method: 'post',
            params: params
        })
    },
    apiAddAdvertiser(data) {
        return request({
            url: api + '/running/advertiser/add',
            method: 'post',
            data
        })
    },
    apiUpdateAdvertiser(data) {
        return request({
            url: api + '/running/advertiser/update',
            method: 'post',
            data
        })
    },
    apiDeleteAdvertiser(params) {
        return request({
            url: api + '/running/advertiser/delete',
            method: 'post',
            params: params
        })
    },
    
    // 广告
    apiGetAds(params) {
        return request({
            url: api + '/running/ad/ad/ads',
            method: 'post',
            params: params
        })
    },
    apiGetAd(params) {
        return request({
            url: api + '/running/ad/ad/ad',
            method: 'post',
            params: params
        })
    },
    apiAddAd(data) {
        return request({
            url: api + '/running/ad/ad/add',
            method: 'post',
            data
        })
    },
    apiUpdateAd(data) {
        return request({
            url: api + '/running/ad/ad/update',
            method: 'post',
            data
        })
    },
    apiDeleteAd(params) {
        return request({
            url: api + '/running/ad/ad/delete',
            method: 'post',
            params: params
        })
    },

    // 广告素材
    apiGetAdMaterials(params) {
        return request({
            url: api + '/running/ad/material/materials',
            method: 'post',
            params: params
        })
    },
    apiGetAdvertiserAdMaterials(params) {
        return request({
            url: api + '/running/ad/material/advertiser',
            method: 'post',
            params: params
        })
    },
    apiGetAdMaterial(params) {
        return request({
            url: api + '/running/ad/material/material',
            method: 'post',
            params: params
        })
    },
    apiAddAdMaterial(data) {
        return request({
            url: api + '/running/ad/material/add',
            method: 'post',
            data
        })
    },
    apiUpdateAdMaterial(data) {
        return request({
            url: api + '/running/ad/material/update',
            method: 'post',
            data
        })
    },
    apiDeleteAdMaterial(params) {
        return request({
            url: api + '/running/ad/material/delete',
            method: 'post',
            params: params
        })
    },
    apiUploadAdMaterialFile() {
        return api + '/running/ad/material/upload';
    },
    
    // 广告位资源
    apiGetAdResources(params) {
        return request({
            url: api + '/running/ad/resource/adresources',
            method: 'post',
            params: params
        })
    },
    apiGetAdResource(params) {
        return request({
            url: api + '/running/ad/resource/adresource',
            method: 'post',
            params: params
        })
    },
    apiAddAdResource(data) {
        return request({
            url: api + '/running/ad/resource/add',
            method: 'post',
            data
        })
    },
    apiUpdateAdResource(data) {
        return request({
            url: api + '/running/ad/resource/update',
            method: 'post',
            data
        })
    },
    apiDeleteAdResource(params) {
        return request({
            url: api + '/running/ad/resource/delete',
            method: 'post',
            params: params
        })
    },
    
    // 广告资源过滤
    apiAdFilterList(params) {
        return request({
            url: api + '/running/ad/filter/list',
            method: 'post',
            params: params
        })
    },
    apiAdFilterEdit(data) {
        return request({
            url: api + '/running/ad/filter/edit',
            method: 'post',
            data: data
        })
    },
    apiAdFilterDelete(params) {
        return request({
            url: api + '/running/ad/filter/delete',
            method: 'post',
            params: params
        })
    },

    // 广告位
    apiGetAdSlots(params) {
        return request({
            url: api + '/running/ad/slot/adslots',
            method: 'post',
            params: params
        })
    },
    apiGetAdSlot(params) {
        return request({
            url: api + '/running/ad/slot/adslot',
            method: 'post',
            params: params
        })
    },
    apiAddAdSlot(data) {
        return request({
            url: api + '/running/ad/slot/add',
            method: 'post',
            data
        })
    },
    apiUpdateAdSlot(data) {
        return request({
            url: api + '/running/ad/slot/update',
            method: 'post',
            data
        })
    },
    apiDeleteAdSlot(params) {
        return request({
            url: api + '/running/ad/slot/delete',
            method: 'post',
            params: params
        })
    },
    apiCopyAdSlot(params) {
        return request({
            url: api + '/running/ad/slot/copy',
            method: 'post',
            params: params
        })
    },
    // 广告投放
    apiAdServiceList(params) {
        return request({
            url: api + '/running/ad/service/list',
            method: 'post',
            params: params
        })
    },
    apiAdServiceEdit(data) {
        return request({
            url: api + '/running/ad/service/edit',
            method: 'post',
            data: data
        })
    },
    apiAdServiceDelete(params) {
        return request({
            url: api + '/running/ad/service/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseFileUpload() {
        return api + '/running/ad/service/file/upload';
    },
    apiAdServiceAppraises(params) {
        return request({
            url: api + '/running/ad/service/appraises',
            method: 'post',
            params: params
        })
    },
    apiAdServiceKnowledges(params) {
        return request({
            url: api + '/running/ad/service/knowledges',
            method: 'post',
            params: params
        })
    },
    
    // 广告场景
    apiGetAdScenes() {
        return request({
            url: api + '/running/ad/scene/scenes',
            method: 'get',
        })
    },
    
    // 积分墙
    apiWalls(data) {
        return request({
            url: api + '/running/integral/walls',
            method: 'get',
            params: Object.assign({ page_index: 1, page_size: 20, }, data)
        })
    },
    apiGetWall(data) {
        return request({
            url: api + '/running/integral/wall',
            method: 'get',
            params: data
        })
    },
    apiAddIntegralWall(data) {
        return request({
            url: api + '/running/integral/wall/add',
            method: 'post',
            data
        })
    },
    apiUpdateIntegralWall(data) {
        return request({
            url: api + '/running/integral/wall/update',
            method: 'put',
            data
        })
    },
    apiDeleteIntegralWall(data) {
        return request({
            url: api + '/running/integral/wall/delete',
            method: 'delete',
            params: data
        })
    },

    // 一致性任务
    apiIntegralUnifys(data) {
        return request({
            url: api + '/running/integral/unifies',
            method: 'get',
            params: data
        })
    },
    apiAddIntegralUnify(data){
        return request({
            url: api + '/running/integral/unify/add',
            method: 'post',
            data
        })
    },

    // 获取任务列表
    apiIntegralTasks(data) {
        return request({
            url: api + '/running/integral/tasks',
            method: 'get',
            params: Object.assign({ page_index: 1, page_size: 20, }, data)
        })
    },

    // 任务
    apiGetIntegralTask(params) {
        return request({
            url: api + '/running/integral/task',
            method: 'get',
            params: params
        })
    },
    apiAddIntegralTask(data) {
        return request({
            url: api + '/running/integral/task/add',
            method: 'post',
            data
        })
    },
    apiUpdateIntegralTask(data) {
        return request({
            url: api + '/running/integral/task/update',
            method: 'put',
            data
        })
    },
    apiDeleteIntegralTask(data) {
        return request({
            url: api + '/running/integral/task/delete',
            method: 'delete',
            params: data
        })
    },
    apiUploadIntegralTaskIcon() {
        return api + '/running/integral/task/uploadIcon';
    },
    // 审核任务
    apiIntegralAudits(data) {
        return request({
            url: api + '/running/integral/audits',
            method: 'get',
            params: Object.assign({ page_index: 1, page_size: 50, }, data)
        })
    },
    apiGetIntegralAudit(params) {
        return request({
            url: api + '/running/integral/audit',
            method: 'get',
            params: params
        })
    },
    apiAddIntegralAudit(data) {
        return request({
            url: api + '/running/integral/audit/add',
            method: 'post',
            data
        })
    },
    apiUpdateIntegralAudit(data) {
        return request({
            url: api + '/running/integral/audit/update',
            method: 'put',
            data
        })
    },
    apiDeleteIntegralAudit(data) {
        return request({
            url: api + '/running/integral/audit/delete',
            method: 'delete',
            params: data
        })
    },
    apiUploadIntegralAuditImage() {
        return api + '/running/integral/audit/uploadImage';
    },
    apiIntegralAuditExecs(data) {
        return request({
            url: api + '/running/integral/audit/execs',
            method: 'post',
            params: data
        })
    },
    apiGetIntegralAuditExec(data) {
        return request({
            url: api + '/running/integral/audit/exec',
            method: 'post',
            params: data
        })
    },
    apiApprovalIntegralAuditExec(data) {
        return request({
            url: api + '/running/integral/audit/approval',
            method: 'put',
            data
        })
    },

    // 测评
    apiAppraiseList(params) {
        return request({
            url: api + '/running/appraise/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseAdd(data) {
        return request({
            url: api + '/running/appraise/add',
            method: 'post',
            data: data
        })
    },
    apiAppraiseUpdate(data) {
        return request({
            url: api + '/running/appraise/update',
            method: 'post',
            data: data
        })
    },
    apiAppraiseDelete(params) {
        return request({
            url: api + '/running/appraise/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseImageUpload() {
        return api + '/running/appraise/image/upload';
    },
    apiAppraiseRefresh(params) {
        return request({
            url: appapi + '/quick/appraise/v1/appraise/refresh',
            method: 'post',
            params: params
        })
    },

    // 测评问题元素
    apiAppraiseQuestionList(params) {
        return request({
            url: api + '/running/appraise/question/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseQuestionEdit(data) {
        return request({
            url: api + '/running/appraise/question/edit',
            method: 'post',
            data: data
        })
    },
    apiAppraiseQuestionDelete(params) {
        return request({
            url: api + '/running/appraise/question/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseQuestionImageUpload() {
        return api + '/running/appraise/question/image/upload';
    },
    apiAppraiseTempletListForQuestion() {
        return request({
            url: api + '/running/appraise/question/templet/list',
            method: 'get'
        })
    },
    apiAppraiseElementListForQuestion(params) {
        return request({
            url: api + '/running/appraise/question/element/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseValueListForQuestion(params) {
        return request({
            url: api + '/running/appraise/question/value/list',
            method: 'post',
            params: params
        })
    },

    // 测评展示
    apiAppraiseExhibitList(params) {
        return request({
            url: api + '/running/appraise/exhibit/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseExhibitEdit(data) {
        return request({
            url: api + '/running/appraise/exhibit/edit',
            method: 'post',
            data: data
        })
    },
    apiAppraiseExhibitDelete(params) {
        return request({
            url: api + '/running/appraise/exhibit/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseTempletListForExhibit(params) {
        return request({
            url: api + '/running/appraise/exhibit/templet/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseElementListForExhibit(params) {
        return request({
            url: api + '/running/appraise/exhibit/element/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseValueListForExhibit(params) {
        return request({
            url: api + '/running/appraise/exhibit/value/list',
            method: 'post',
            params: params
        })
    },
    
    // 测评评分元素
    apiAppraiseScoreList(params) {
        return request({
            url: api + '/running/appraise/score/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseScoreEdit(data) {
        return request({
            url: api + '/running/appraise/score/edit',
            method: 'post',
            data: data
        })
    },
    apiAppraiseScoreDelete(params) {
        return request({
            url: api + '/running/appraise/score/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseScoreImageUpload() {
        return api + '/running/appraise/score/image/upload';
    },

    // 测评限制
    apiAppraiseLimitList(params) {
        return request({
            url: api + '/running/appraise/limit/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseLimitEdit(data) {
        return request({
            url: api + '/running/appraise/limit/edit',
            method: 'post',
            data: data
        })
    },
    apiAppraiseLimitDelete(params) {
        return request({
            url: api + '/running/appraise/limit/delete',
            method: 'post',
            params: params
        })
    },
    
    // 测评模版
    apiAppraiseTempletList(params) {
        return request({
            url: api + '/running/appraise/templet/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseTempletAdd(data) {
        return request({
            url: api + '/running/appraise/templet/add',
            method: 'post',
            data: data
        })
    },
    apiAppraiseTempletUpdate(data) {
        return request({
            url: api + '/running/appraise/templet/update',
            method: 'post',
            data: data
        })
    },
    apiAppraiseTempletDelete(params) {
        return request({
            url: api + '/running/appraise/templet/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseTempletImageUpload() {
        return api + '/running/appraise/templet/image/upload';
    },

    // 测评模版元素
    apiAppraiseElementList(params) {
        return request({
            url: api + '/running/appraise/element/list',
            method: 'post',
            params: params
        })
    },
    apiAppraiseElementEdit(data) {
        return request({
            url: api + '/running/appraise/element/edit',
            method: 'post',
            data: data
        })
    },
    apiAppraiseElementDelete(params) {
        return request({
            url: api + '/running/appraise/element/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseElementImageUpload() {
        return api + '/running/appraise/element/image/upload';
    },
    
    // 测评模版元素值
    apiAppraiseValueEdit(data) {
        return request({
            url: api + '/running/appraise/value/edit',
            method: 'post',
            data: data
        })
    },
    apiAppraiseValueDelete(params) {
        return request({
            url: api + '/running/appraise/value/delete',
            method: 'post',
            params: params
        })
    },
    apiAppraiseValueImageUpload() {
        return api + '/running/appraise/value/image/upload';
    },

    // 知识
    apiKnowledgeList(params) {
        return request({
            url: api + '/running/knowledge/list',
            method: 'post',
            params: params
        })
    },
    apiKnowledgeAdd(data) {
        return request({
            url: api + '/running/knowledge/add',
            method: 'post',
            data: data
        })
    },
    apiKnowledgeUpdate(data) {
        return request({
            url: api + '/running/knowledge/update',
            method: 'post',
            data: data
        })
    },
    apiKnowledgeDelete(params) {
        return request({
            url: api + '/running/knowledge/delete',
            method: 'post',
            params: params
        })
    },
    apiKnowledgeImageUpload() {
        return api + '/running/knowledge/image/upload';
    },
    apiKnowledgePictureUpload(data) {
        return request({
            url: api + '/running/knowledge/picture/upload',
            method: 'post',
            data: data
        })
    },
    apiKnowledgeAppraises(params) {
        return request({
            url: api + '/running/knowledge/appraises',
            method: 'post',
            params: params
        })
    },

    // 知识分类
    apiKnowledgeClasses() {
        return request({
            url: api + '/running/knowledge/class/list',
            method: 'get'
        })
    },

    // 知识合集
    apiKnowledgeCollects() {
        return request({
            url: api + '/running/knowledge/collect/list',
            method: 'get'
        })
    },
    apiKnowledgeCollectEdit(data) {
        return request({
            url: api + '/running/knowledge/collect/edit',
            method: 'post',
            data: data
        })
    },
    apiKnowledgeCollectDelete(params) {
        return request({
            url: api + '/running/knowledge/collect/delete',
            method: 'post',
            params: params
        })
    },
    
    // 知识模版
    apiKnowledgeTempletList(params) {
        return request({
            url: api + '/running/knowledge/templet/list',
            method: 'post',
            params: params
        })
    },
    apiKnowledgeTempletAdd(data) {
        return request({
            url: api + '/running/knowledge/templet/add',
            method: 'post',
            data: data
        })
    },
    apiKnowledgeTempletUpdate(data) {
        return request({
            url: api + '/running/knowledge/templet/update',
            method: 'post',
            data: data
        })
    },
    apiKnowledgeTempletDelete(params) {
        return request({
            url: api + '/running/knowledge/templet/delete',
            method: 'post',
            params: params
        })
    },
    apiKnowledgeTempletImageUpload() {
        return api + '/running/knowledge/templet/image/upload';
    },

    // 小说
    apiBookList(params) {
        return request({
            url: api + '/running/book/list',
            method: 'post',
            params: params
        })
    },
    apiBookAdd(data) {
        return request({
            url: api + '/running/book/add',
            method: 'post',
            data: data
        })
    },
    apiBookUpdate(data) {
        return request({
            url: api + '/running/book/update',
            method: 'post',
            data: data
        })
    },
    apiBookDelete(params) {
        return request({
            url: api + '/running/book/delete',
            method: 'post',
            params: params
        })
    },
    apiBookImageUpload() {
        return api + '/running/book/image/upload';
    },
    apiBookRefresh(params) {
        return request({
            url: appapi + '/quick/book/v1/book/refresh',
            method: 'post',
            params: params
        })
    },

    // 小说章节
    apiBookChapterList(params) {
        return request({
            url: api + '/running/book/chapter/list',
            method: 'post',
            params: params
        })
    },
    apiBookChapterEdit(data) {
        return request({
            url: api + '/running/book/chapter/edit',
            method: 'post',
            data: data
        })
    },
    apiBookChapterDelete(params) {
        return request({
            url: api + '/running/book/chapter/delete',
            method: 'post',
            params: params
        })
    },

    // 小说限制
    apiBookLimitList(params) {
        return request({
            url: api + '/running/book/limit/list',
            method: 'post',
            params: params
        })
    },
    apiBookLimitEdit(data) {
        return request({
            url: api + '/running/book/limit/edit',
            method: 'post',
            data: data
        })
    },
    apiBookLimitDelete(params) {
        return request({
            url: api + '/running/book/limit/delete',
            method: 'post',
            params: params
        })
    },

    // 壁纸
    apiWallpaperList(params) {
        return request({
            url: api + '/running/wallpaper/list',
            method: 'post',
            params: params
        })
    },
    apiWallpaperAdd(data) {
        return request({
            url: api + '/running/wallpaper/add',
            method: 'post',
            data: data
        })
    },
    apiWallpaperUpdate(data) {
        return request({
            url: api + '/running/wallpaper/update',
            method: 'post',
            data: data
        })
    },
    apiWallpaperDelete(params) {
        return request({
            url: api + '/running/wallpaper/delete',
            method: 'post',
            params: params
        })
    },
    apiWallpaperImageUpload() {
        return api + '/running/wallpaper/image/upload';
    },
    apiWallpaperRefresh(params) {
        return request({
            url: appapi + '/quick/appraise/v1/wallpaper/refresh',
            method: 'post',
            params: params
        })
    },

    // 短剧
    apiShortplayList(params) {
        return request({
            url: api + '/running/shortplay/list',
            method: 'post',
            params: params
        })
    },
    apiShortplayAdd(data) {
        return request({
            url: api + '/running/shortplay/add',
            method: 'post',
            data: data
        })
    },
    apiShortplayUpdate(data) {
        return request({
            url: api + '/running/shortplay/update',
            method: 'post',
            data: data
        })
    },
    apiShortplayDelete(params) {
        return request({
            url: api + '/running/shortplay/delete',
            method: 'post',
            params: params
        })
    },
    apiShortplayImageUpload() {
        return api + '/running/shortplay/image/upload';
    },
    apiShortplayRefresh(params) {
        return request({
            url: appapi + '/quick/book/v1/shortplay/refresh',
            method: 'post',
            params: params
        })
    },

    // 短剧剧集
    apiShortplayEpisodeList(params) {
        return request({
            url: api + '/running/shortplay/episode/list',
            method: 'post',
            params: params
        })
    },
    apiShortplayEpisodeEdit(data) {
        return request({
            url: api + '/running/shortplay/episode/edit',
            method: 'post',
            data: data
        })
    },
    apiShortplayEpisodeDelete(params) {
        return request({
            url: api + '/running/shortplay/episode/delete',
            method: 'post',
            params: params
        })
    },
    apiShortplayEpisodeVideoUpload() {
        return api + '/running/shortplay/episode/video/upload';
    },

    // 短剧限制
    apiShortplayLimitList(params) {
        return request({
            url: api + '/running/shortplay/limit/list',
            method: 'post',
            params: params
        })
    },
    apiShortplayLimitEdit(data) {
        return request({
            url: api + '/running/shortplay/limit/edit',
            method: 'post',
            data: data
        })
    },
    apiShortplayLimitDelete(params) {
        return request({
            url: api + '/running/shortplay/limit/delete',
            method: 'post',
            params: params
        })
    },
    
    // 商品
    apiCommodities(params) {
        return request({
            url: api + '/running/commodity/commodities',
            method: 'post',
            params: params
        })
    },
    apiCommodityMode(params) {
        return request({
            url: api + '/running/commodity/mode',
            method: 'post',
            params: params
        })
    },
    apiCommodityBlacklist(params) {
        return request({
            url: api + '/running/commodity/blacklist',
            method: 'post',
            params: params
        })
    },
    apiCommodityAddChoice(params) {
        return request({
            url: api + '/running/commodity/choice/add',
            method: 'post',
            params: params
        })
    },

    // 商品选品
    apiCommodityChoices(params) {
        return request({
            url: api + '/running/commodity/choices',
            method: 'post',
            params: params
        })
    },
    apiCommodityChoiceMode(params) {
        return request({
            url: api + '/running/commodity/choice/mode',
            method: 'post',
            params: params
        })
    },
    apiCommodityChoiceRanking(params) {
        return request({
            url: api + '/running/commodity/choice/ranking',
            method: 'post',
            params: params
        })
    },
    apiCommodityChoiceDelete(params) {
        return request({
            url: api + '/running/commodity/choice/delete',
            method: 'post',
            params: params
        })
    },

    // 应用概况统计
    apiStatSummary(params){
        return request({
            url: api + '/running/appstat/summary',
            method: 'get',
            params: params
        })
    },
    // 应用访问统计
    apiAppStatVisits(params){
        return request({
            url: api + '/running/appstat/visits',
            method: 'get',
            params: params
        });
    },
    // 应用用户统计
    apiAppStatUsers(params){
        return request({
            url: api + '/running/appstat/users',
            method: 'get',
            params: params
        });
    },
    // 应用任务统计
    apiAppStatTasks(params){
        return request({
            url: api + '/running/appstat/tasks',
            method: 'get',
            params: params
        });
    },
    // 应用广告统计
    apiAppStatAds(params){
        return request({
            url: api + '/running/appstat/ads',
            method: 'get',
            params: params
        })
    },
    // 财务统计
    apiGetAppStatFinancial(params){
        return request({
            url: api + '/running/appstat/financial',
            method: 'get',
            params: params
        })
    },
    // 财务明细
    apiGetAppStatFinances(params) {
        return request({
            url: api + '/running/appstat/finances',
            method: 'post',
            params: params
        })
    },
    apiGetAppStatFinance(params) {
        return request({
            url: api + '/running/appstat/finance',
            method: 'post',
            params: params
        })
    },
    apiAddAppStatFinance(params) {
        return request({
            url: api + '/running/appstat/finance/add',
            method: 'post',
            params: params
        })
    },
    apiUpdateAppStatFinance(params) {
        return request({
            url: api + '/running/appstat/finance/update',
            method: 'post',
            params: params
        })
    },
    apiDeleteAppStatFinance(params) {
        return request({
            url: api + '/running/appstat/finance/delete',
            method: 'post',
            params: params
        })
    },
    // 应用动作统计
    apiAppStatActions(params){
        return request({
            url: api + '/running/appstat/action/actions',
            method: 'post',
            params: params
        });
    },
    // 应用子动作统计
    apiAppStatSubActions(params){
        return request({
            url: api + '/running/appstat/action/subactions',
            method: 'post',
            params: params
        });
    },

    // 快应用广告报表
    apiLuckyStatAd(params){
        return request({
            url: api + '/running/luckystat/ad',
            method: 'post',
            params: params
        })
    },
    // 快应用广告报表-新
    apiLuckyStatAdrpt(params){
        return request({
            url: api + '/running/luckystat/adrpt',
            method: 'post',
            params: params
        })
    },
    // 快应用百度报表
    apiLuckyStatBaidu(params){
        return request({
            url: api + '/running/luckystat/baidu/list',
            method: 'post',
            params: params
        })
    },
    apiSaveLuckyBaidu(params){
        return request({
            url: api + '/running/luckystat/baidu/save',
            method: 'post',
            params: params
        })
    },
    apiDeleteLuckyBaidu(params){
        return request({
            url: api + '/running/luckystat/baidu/delete',
            method: 'post',
            params: params
        })
    },
    apiUploadLuckyBaiduFile(){
        return api + '/running/luckystat/baidu/upload';
    },
    // 快应用营销报表
    apiLuckyStatOppo(params){
        return request({
            url: api + '/running/luckystat/oppo',
            method: 'post',
            params: params
        })
    },
    // 快应用亏损报表
    apiLuckyStatLoss(params){
        return request({
            url: api + '/running/luckystat/loss',
            method: 'post',
            params: params
        })
    },
    apiQuickMarketManuals(params){
        return request({
            url: api + '/running/luckystat/market/manual/list',
            method: 'post',
            params: params
        })
    },
    apiQuickMarketManualSave(data){
        return request({
            url: api + '/running/luckystat/market/manual/save',
            method: 'post',
            data: data
        })
    },
    apiQuickMarketManualDelete(params){
        return request({
            url: api + '/running/luckystat/market/manual/delete',
            method: 'post',
            params: params
        })
    },
    // 快应用快照报表
    apiQuickMarketSnapList(params){
        return request({
            url: api + '/running/luckystat/snap/list',
            method: 'post',
            params: params
        })
    },
    // 效果数据回传
    apiCommonEffectGet(params){
        return request({
            url: api + '/running/common/effect/get',
            method: 'post',
            params: params
        })
    },
    apiCommonEffectSet(params){
        return request({
            url: api + '/running/common/effect/set',
            method: 'post',
            params: params
        })
    },
    apiCommonEffectSetRate(params){
        return request({
            url: api + '/running/common/effect/set/rate',
            method: 'post',
            params: params
        })
    },
    // 操作日志查询
    apiCommonOperateLogs(params){
        return request({
            url: api + '/running/common/operatelog/list',
            method: 'post',
            params: params
        })
    },
    
    // 快应用投放
    apiQuickAppIssueList(params){
        return request({
            url: api + '/running/luckystat/appissue/list',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueAuthorizes(params){
        return request({
            url: api + '/running/luckystat/appissue/authorizes',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueAdd(params){
        return request({
            url: api + '/running/luckystat/appissue/add',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueBatchUpload(cid) {
        return api + '/running/luckystat/appissue/upload?channelId=' + cid;
    },
    apiQuickAppIssueBatchAdd(data){
        return request({
            url: api + '/running/luckystat/appissue/batchadd',
            method: 'post',
            data: data
        })
    },
    apiQuickAppIssueUpdate(params){
        return request({
            url: api + '/running/luckystat/appissue/update',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueDelete(params){
        return request({
            url: api + '/running/luckystat/appissue/delete',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueChannelSlots(params){
        return request({
            url: api + '/running/luckystat/appissue/channelslots',
            method: 'post',
            params: params
        })
    },
    // 快应用目标
    apiQuickAppTargets(params){
        return request({
            url: api + '/running/luckystat/target',
            method: 'post',
            params: params
        })
    },
    
    // 合作伙伴快应用营销报表
    apiPartnerQuickMarketList(params){
        return request({
            url: api + '/running/partner/market/list',
            method: 'post',
            params: params
        })
    },

    // 快应用黑明单
    apiQuickAppIssueBlacklistFind(params){
        return request({
            url: api + '/running/luckystat/blacklist/find',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueBlacklistIpSet(params){
        return request({
            url: api + '/running/luckystat/blacklist/ip/set',
            method: 'post',
            params: params
        })
    },
    apiQuickAppIssueBlacklistOaidSet(params){
        return request({
            url: api + '/running/luckystat/blacklist/oaid/set',
            method: 'post',
            params: params
        })
    },

    // 效果手工回传
    apiQuickAppEtaskList(params){
        return request({
            url: api + '/running/luckystat/appetask/list',
            method: 'post',
            params: params
        })
    },
    apiQuickAppEtaskAdd(data){
        return request({
            url: api + '/running/luckystat/appetask/add',
            method: 'post',
            data: data
        })
    },
    apiQuickAppEtaskUpdate(data){
        return request({
            url: api + '/running/luckystat/appetask/update',
            method: 'post',
            data: data
        })
    },
    apiQuickAppEtaskDelete(params){
        return request({
            url: api + '/running/luckystat/appetask/delete',
            method: 'post',
            params: params
        })
    },
    apiQuickAppEtaskIssue(params){
        return request({
            url: api + '/running/luckystat/appetask/issue',
            method: 'post',
            params: params
        })
    },
    apiQuickAppEtaskEffect(params){
        return request({
            url: api + '/running/luckystat/appetask/effect',
            method: 'post',
            params: params
        })
    },
    
    // 合作伙伴快应用快照报表
    apiPartnerQuickMarketSnapList(params){
        return request({
            url: api + '/running/partner/snap/list',
            method: 'post',
            params: params
        })
    },

    // 合作伙伴快应用发布
    apiPartnerQuickAppIssueList(params){
        return request({
            url: api + '/running/partner/appissue/list',
            method: 'post',
            params: params
        })
    },
    apiPartnerQuickAppIssueAdd(data){
        return request({
            url: api + '/running/partner/appissue/add',
            method: 'post',
            data: data
        })
    },
    apiPartnerQuickAppIssueUpdate(data){
        return request({
            url: api + '/running/partner/appissue/update',
            method: 'post',
            data: data
        })
    },
    apiPartnerQuickAppIssueDelete(params){
        return request({
            url: api + '/running/partner/appissue/delete',
            method: 'post',
            params: params
        })
    },
    apiPartnerQuickOiedApply(data){
        return request({
            url: api + '/running/partner/oied/apply',
            method: 'post',
            data: data
        })
    },
    
    // 合作伙伴公共接口
    apiPartnerCommonApps(params){
        return request({
            url: api + '/running/partner/common/apps',
            method: 'post',
            params: params
        })
    },
    apiPartnerCommonChannels(params){
        return request({
            url: api + '/running/partner/common/channels',
            method: 'post',
            params: params
        })
    },
    apiPartnerCommonChannelSlots(params){
        return request({
            url: api + '/running/partner/common/channel/slots',
            method: 'post',
            params: params
        })
    },
    
    // 登录
    apiLogin(params){
        return request({
            url: api + '/running/login',
            method: 'post',
            params: params
        })
    },

    // 找回密码
    apiFindPassword(params){
        return request({
            url: api + '/running/findpassword',
            method: 'post',
            params: params
        })
    },

    // 刷新任务
    apiRefreshMoneyTasks() {
        return request({
            url: appapi + '/alipay/money/v1/task/itasks/refresh',
            method: 'get',
        })
    },
    apiRefreshRichTasks() {
        return request({
            url: appapi + '/alipay/rich/v1/task/itasks/refresh',
            method: 'get',
        })
    },
    apiRefreshWalkingTasks() {
        return request({
            url: appapi + '/alipay/walking/v1/task/itasks/refresh',
            method: 'get',
        })
    },
    apiRefreshWealthTasks() {
        return request({
            url: appapi + '/alipay/wealth/v1/task/itasks/refresh',
            method: 'get',
        })
    },
    apiRefreshAdResources(params) {
        return request({
            url: appapi + '/quick/support/v1/ad/resource/load',
            method: 'get',
            params: params
        })
    },

    // 刷新福利
    apiRefreshWelfares(params) {
        return request({
            url: appapi + '/rich/v1/welfare/refresh',
            method: 'get',
            params: params,
        })
    },

    // 操作员
    apiGetOperators(params) {
        return request({
            url: api + '/running/operator/operator/operators',
            method: 'post',
            params: params
        })
    },
    apiAddOperator(data) {
        return request({
            url: api + '/running/operator/operator/add',
            method: 'post',
            data
        })
    },
    apiUpdateOperator(data) {
        return request({
            url: api + '/running/operator/operator/update',
            method: 'post',
            data
        })
    },
    apiDeleteOperator(params) {
        return request({
            url: api + '/running/operator/operator/delete',
            method: 'post',
            params: params
        })
    },
    apiGetOperatorRoles(params) {
        return request({
            url: api + '/running/operator/operator/roles',
            method: 'post',
            params: params
        })
    },

    // 操作员应用授权
    apiGetOperatorAppAuthorizes(params) {
        return request({
            url: api + '/running/operator/operator/appauthorize/list',
            method: 'post',
            params: params
        })
    },
    apiEditOperatorAppAuthorize(data) {
        return request({
            url: api + '/running/operator/operator/appauthorize/edit',
            method: 'post',
            data
        })
    },
    apiDeleteOperatorAppAuthorize(params) {
        return request({
            url: api + '/running/operator/operator/appauthorize/delete',
            method: 'post',
            params: params
        })
    },

    // 修改密码
    apiOperatorPasswordAuthCode(params) {
        return request({
            url: api + '/running/operator/password/authcode',
            method: 'post',
            params: params
        })
    },
    apiOperatorPasswordChange(params) {
        return request({
            url: api + '/running/operator/password/change',
            method: 'post',
            params: params
        })
    },
}
